var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bulb_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M633.344 867.747h-230.12a7.68 7.68 0 0 0-7.634 7.68V906.1c0 16.943 13.684 30.674 30.673 30.674h184.088c16.942 0 30.72-13.731 30.72-30.72v-30.627a7.68 7.68 0 0 0-7.727-7.68zM518.284 77.684a314.554 314.554 0 0 0-157.23 586.892V775.68c0 16.99 13.73 30.72 30.72 30.72H644.84c16.989 0 30.72-13.73 30.72-30.72V664.576A314.554 314.554 0 0 0 518.33 77.638zM640.93 604.812l-34.444 19.968v112.547H430.08V624.78l-34.444-19.968a245.434 245.434 0 1 1 245.295 0z"
  })));
};
export default SvgBulb;